import { SessionData, WellList } from './NgsoReducer'

export const EmptyWellPlate: WellList = {
  __typename: '',
  additionalComments: '',
  additionalServices: [],
  amount: '',
  analyticalHPLC: '',
  baseCount: 0,
  category: '',
  certificateOfAnalysis: '',
  column: '',
  comments: '',
  concentration: '',
  countryCode: '',
  crossContamination: '',
  currency: '',
  currencySymbol: '',
  epsilon: 0,
  excessMaterial: false,
  fiveMod: '',
  flag: 0,
  format: '',
  gcContent: '',
  id: 0,
  isOverridden: false,
  listAdditionalServices: [],
  listError: [],
  listISO: [],
  listNgso: [],
  listWarning: [],
  meltingTemparature: '',
  molecularWeight: '',
  name: '',
  ngsoType: '',
  oligoId: 0,
  orderItemId: ' ',
  other: '',
  packageType: '',
  pageNo: 0,
  price: '',
  priceHeaderError: '',
  primerDimer: '',
  productType: '',
  purification: '',
  qualitySystem: '',
  row: '',
  scale: '',
  secondaryStructure: '',
  sequence: '',
  shipping: '',
  technicalSequence: '',
  terms: false,
  threeMod: '',
  tubes: 1,
  wellType: 0,
}

export const EmptyNgsoSession: SessionData = {
  __typename: '',
  amount: '',
  applyToAll: false,
  biTubeWellList: [],
  category: '',
  channelType: 0,
  concentration: '',
  countOfWells: 0,
  countryCode: '',
  daughterPlateCount: '',
  format: '',
  isAmountSelected: false,
  isCSR: false,
  isCSRSupervisor: false,
  isConcentrationOther: false,
  isConcentrationSelected: false,
  isOverridden: false,
  isPackageTypeOther: false,
  isShippingOverridden: false,
  isSpecificationsOverridden: false,
  material: '',
  packageType: '',
  pageNo: 0,
  plateCopiesRange: '',
  plateId: 1,
  plateName: '',
  plateNameError: [],
  plateType: '',
  productType: 'ngsotubes',
  purification: '',
  researcher: '',
  researcherNameError: [],
  scale: '',
  selectedPackageType: '',
  shipping: '',
  stockPlate: '',
  totalBaseCount: 0,
  wellList: [EmptyWellPlate],
  wellType: 0,
}
